import { SelectChangeEvent, Dialog, DialogContent, DialogTitle, FormControl, styled, List, ListItem, ListItemText, Paper, tableCellClasses, Tooltip, Select, Stack, Typography, Grid, Divider, ListItemAvatar, Avatar, useMediaQuery, InputLabel, IconButton, Menu, TableRow, TableCell, TableContainer, Table, TableHead, TableBody, CircularProgress, Button } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ListIcon from '@mui/icons-material/List';
import { Box } from '@mui/system';
import { MY_TEAM_DOWNLOAD_TITLES, REPORT_TABLE } from '../../shared/constants';
import React, { ChangeEvent, Fragment, useEffect, useState } from 'react';
import { generateRandomLightColor } from '../../assets/color/RandomColor';
import { useSelector } from 'react-redux';
import { Project } from '../ManageProjects/ManageProjects';
import { DataGrid, GridCellParams, GridCloseIcon } from '@mui/x-data-grid';
import ExcelJS from 'exceljs';
import { RootState } from '../../redux-toolkit/store/stateType';
import constants from '../../shared/constants';
import { getMonthlySummaryAllExceptions, getMonthlySummaryException, getProjectData, getUserReportData, getMyTeamProjectData } from '../../services/reportService';
import dayjs, { Dayjs } from 'dayjs';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { AlertType } from '../DataGrid/MuiDataGrid';
import { getReportsMyTeamColumnDefs } from '../DataGrid/myTeamReportGrid';
import { generateHeadersForMonth } from '../../helper/columnModifier';
import generateExcelReport from '../../helper/excelHelper';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CustomDateRangePicker from './CustomDateRangePicker';
import MyTeamStyles from './MyTeamStyles';
import FileSaver from 'file-saver';
import generateTeamReport from '../../helper/teamReport';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import { getStyles } from '../DataGrid/MuiDataGridStyle';
import { useTheme } from '@emotion/react';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { User } from '../../redux-toolkit/reducers/userReducer';

interface LoadingState {
	[key: number]: boolean;
}

type ReportRequest = {
	username: string;
	startDate: number;
	endDate: number;
}

interface Report {
	employee: string;
	projectName: string;
	activityType: string;
	feature: string;
	workDescription: string;
	activityDate: string;
	activityDuration: string;
	workMode: string;
}

export const MyTeam = () => {
	const projects: Project[] = useSelector((state: any) => state.projects);
	const employees: any = useSelector((state: any) => state.employees);
	const user = useSelector((state: any) => state.user);
	const theme = useTheme();
	const Style = getStyles(theme);
	const [page, setPage] = useState<number>(1);
	const [open, setOpen] = useState(false);
	const [openSelectField, setOpenSelectfield] = useState(false);
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const [teamMemberReport, setTeamMemberReport] = useState([]);
	const reportPopOverId = open ? 'add-report-popover' : undefined;
	const [isFetching, setIsFetching] = useState(false);
	const [monthSelected, setMonthSelected] = useState('');
	const [employeeName, setEmployeeName] = useState('');
	const [projectLead, setProjectLead] = useState('');
	const [projectName, setProjectName] = useState('');
	const [openGrid, setOpenGrid] = useState(false);
	const [showAlert, setShowAlert] = useState<AlertType>();
	const [warningMessage, setWarningMessage] = useState('');
	const [workDuration, setWorkDuration] = useState(0);
	const [weeklyReportStart, setWeeklyReportStart] = useState('');
	const [weeklyReportEnds, setWeeklyReportEnds] = useState('');
	const [weeklySummaryDialogue, setWeeklySummaryDialogue] = useState(false);
	const [weeklySummaryReport, setWeeklySummaryReport] = useState({});
	const [responseData, setResponseData] = useState([]);
	const [projectData, setProjectData] = useState({});
	const [formatData, setFormattedData] = useState([]);
	const [featureSummaryReport, setFeatureSummaryReport] = useState([]);
	const [isEmptyData, setisemptyData] = useState(true);
	const [isUserLoading, setIsUserLoading] = useState(false);
	const [isLoading, setIsLoading] = useState<LoadingState>({});
	const [isTimelineLoading, setIsTimelineLoading] = useState<LoadingState>({});
	const [isTeamReportLoading, setIsTeamReportLoading] = useState<LoadingState>({});
	const [isFeatureLoading, setIsFeatureLoading] = useState<LoadingState>({});
	const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | null>(dayjs());
	const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | null>(dayjs());
	const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
	const [isProjectLoading, setIsProjectLoading] = useState(false);
	const [showDatagrid, setShowDatagrid] = useState(false);
	const [isPlanForDay, setIsPlanForDay] = useState<any[]>([]);
	const [isSelectedData, setIsSelectedData] = useState<any[]>([]);
	const [loadingState, setLoadingState] = useState({
		teamReport: false,
		timeline: false,
		feature: false,
	});

	const handleDownloadClick = (event: any, project: any) => {
		event.stopPropagation();
		setDownloadAnchorEl(event.currentTarget);
		setProjectData(project);
	};

	const handleDownloadClose = () => {
		setDownloadAnchorEl(null);
	};
	// let totalDuration = 0;
	const handleCustomDateChange = (startDate: Dayjs, endDate: Dayjs | null = null) => {
		setSelectedStartDate(startDate);
		setSelectedEndDate(endDate);
	};

	const openMenu = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};


	const [adminReport, setAdminReport] = useState<boolean>(user.employeeType === constants.EMPLOYEE_TYPES.ADMIN ?
		window.localStorage.getItem('ADMIN_REPORT') === 'true'
			? true
			: false :
		true
	);
	const { reports, count: reportsCount, features } = useSelector((state: RootState) => state.reports);
	const isSmallScreen = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
	const projectsWithUser: any = projects.filter((item: any) => (item.employeesWorking && item.employeesWorking.includes(`${user.firstName} ${user.lastName}`)) || item.projectManger === user.userName || item.projectLead === user.userName);
	const newProject = projectsWithUser
		.filter((item: any) => item.projectStatus)
		.map((pro: any) => {
			const myProjectTeam = { ...pro };
			myProjectTeam.employeesWorking = pro.employeesWorking ? pro.employeesWorking.split(',') : [];
			myProjectTeam.displayProjectName = pro.displayProjectName;
			employees.forEach((emp: any) => {
				if (emp.userName === pro.projectManger) {
					myProjectTeam.projectManger = `${emp.firstName} ${emp.lastName}`;
				}
				if (emp.userName === pro.projectLead) {
					myProjectTeam.projectLead = `${emp.firstName} ${emp.lastName}`;
				}
			});

			return myProjectTeam;
		});
	const StyledTableCell = styled(TableCell)(({ theme: any }) => ({
		[`&.${tableCellClasses.head}`]: {
			backgroundColor: '#ffddca',
			color: '#F26A22',
		},
		[`&.${tableCellClasses.body}`]: {
			fontSize: 14,
		},
	}));
	const BootstrapDialog = styled(Dialog)(({ theme }) => ({
		'& .MuiDialogContent-root': {
			padding: theme.spacing(2),
		},
		'& .MuiDialogActions-root': {
			padding: theme.spacing(1),
		},
		'& .MuiDialog-paper': {
			maxWidth: '1000px',
		}
	}));
	const handleCloseDialogueBox = () => {
		setWeeklySummaryDialogue(false);

	};

	const handleProjectNameSummary = async (employeesWorking: unknown, projectName: string) => {
		try {
			setIsProjectLoading(true);
			setShowDatagrid(true);
			setProjectName(projectName);

			const limit = 100;
			const res = await getMyTeamProjectData(constants.ORGANISATION_ID, projectName, undefined, limit);
			const projectData = res?.data?.res?.Items || [];

			// Filter data for planning and selected reports
			const plannedData = projectData.filter((report: { activityDuration?: number | string }) =>
				report.activityDuration === '' || report.activityDuration === 0
			);

			const selectedData = projectData.filter((r: { activityDuration?: unknown }) =>
				!!r.activityDuration // Removes falsy values: 0, "", null, undefined
			);

			setIsPlanForDay(plannedData);
			setIsSelectedData(selectedData);
		} catch (error) {
			console.error('Error in handleProjectNameSummary:', error);
			setShowDatagrid(false);
		} finally {
			setIsProjectLoading(false);
		}
	};


	const handleSummary = async (employeesWorking: any, projectName: any, projectLead: any, index: any) => {
		setIsLoading({ ...isLoading, [index]: true });
		const today = new Date();
		const oneWeekAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
		const lastWeekStartDate = new Date(oneWeekAgo.getFullYear(), oneWeekAgo.getMonth(), oneWeekAgo.getDate() - oneWeekAgo.getDay());
		const lastWeekEndDate = new Date(oneWeekAgo.getFullYear(), oneWeekAgo.getMonth(), oneWeekAgo.getDate() - oneWeekAgo.getDay() + 6);
		const weekStartEpoche: number = Date.parse(lastWeekStartDate.toString());
		const weekEndEpoche: number = Date.parse(lastWeekEndDate.toString());
		const firstDayEpoch = dayjs(selectedStartDate).valueOf();
		const lastDayEpoch = dayjs(selectedEndDate).valueOf();

		setWeeklyReportStart(dayjs(selectedStartDate).format('DD-MMM-YYYY'));
		setWeeklyReportEnds(dayjs(selectedEndDate).format('DD-MMM-YYYY'));

		const employeeUserNames: any = [];
		employeesWorking.map((data: any) => {
			const filteredData = employees.filter((item: any) => `${item.firstName} ${item.lastName}` === data);
			if (filteredData.length > 0) {
				const userName = filteredData[0].userName;
				employeeUserNames.push(userName);

			}
		});

		employees.map((employee: any) => {
			if (
				employee.firstName === projectLead?.split(' ')[0] &&
				employee.lastName === projectLead?.split(' ')[1]
			) {
				employeeUserNames.push(employee.userName);
			}
		});

		const data = await getProjectData(employeeUserNames, firstDayEpoch, lastDayEpoch).then((res: any) => {

			const responsedata = res.data.mergedItems.Items;
			const userReportsData = responsedata.filter((item: any) => item.projectName === projectName);
			const employeeNames: any = [];
			responsedata.forEach((report: any) => {
				const matchingEmployee = employees.find((employee: any) => employee.userName === report.userName);
				if (matchingEmployee) {
					const { firstName } = matchingEmployee;
					employeeNames.push(firstName);

				}
			});

			const lastWeekSummary: any = {};
			for (let i = 0; i < userReportsData.length; i++) {
				lastWeekSummary[userReportsData[i].userName] = {};
			}
			for (const key in lastWeekSummary) {
				const categoryList: { [key: string]: any } = {};
				REPORT_TABLE.ACTIVITIES.forEach((element) => {
					categoryList[element] = { workitem: [], duration: 0 };
				});
				lastWeekSummary[key] = categoryList;
			}
			userReportsData.forEach((element: any) => {

				const categoryName = element.activityType;
				const userName = element.userName;
				lastWeekSummary[userName][categoryName].workitem.push(element.workDescription);
				lastWeekSummary[userName][categoryName].duration =
					parseFloat(
						(lastWeekSummary[userName][categoryName].duration +
							(isNaN(parseFloat(element.activityDuration)) ? 0 : parseFloat(element.activityDuration))
						).toFixed(2));
				// totalDuration += element.activityDuration;
			});

			const isEmptyData = Object.values(lastWeekSummary).every((obj: any) => Object.keys(obj).length === 0);
			setisemptyData(isEmptyData);
			setFormattedData(lastWeekSummary);

			//based on feature
			const featureLastWeekSummary: any = {};
			for (let i = 0; i < userReportsData.length; i++) {
				featureLastWeekSummary[userReportsData[i].userName] = {};
			}

			userReportsData.forEach((element: any) => {

				const featureName = element.feature;
				const userName = element.userName;

				if (featureName === '') {
					if (!featureLastWeekSummary[userName]['']) {
						featureLastWeekSummary[userName][''] = { workitem: [], duration: 0 };
					}
					featureLastWeekSummary[userName][''].workitem.push(element.workDescription);
					featureLastWeekSummary[userName][''].duration =
						parseFloat(
							(featureLastWeekSummary[userName][''].duration +
								(isNaN(parseFloat(element.activityDuration)) ? 0 : parseFloat(element.activityDuration))
							).toFixed(2));
				} else {
					if (!featureLastWeekSummary[userName][featureName]) {
						featureLastWeekSummary[userName][featureName] = { workitem: [], duration: 0 };
					}
					featureLastWeekSummary[userName][featureName].workitem.push(element.workDescription);
					featureLastWeekSummary[userName][featureName].duration =
						parseFloat(
							(featureLastWeekSummary[userName][featureName].duration +
								(isNaN(parseFloat(element.activityDuration)) ? 0 : parseFloat(element.activityDuration))
							).toFixed(2));
				}

				// totalDuration += element.activityDuration;
			});

			for (const key in featureLastWeekSummary) {
				const projectDetails = featureLastWeekSummary[key];
				for (const task in projectDetails) {
					if (task === 'undefined') {
						delete projectDetails[task];
					}
				}
			}

			for (const key in featureLastWeekSummary) {
				if (Object.keys(featureLastWeekSummary[key]).length === 0) {
					delete featureLastWeekSummary[key];
				}
			}

			const isEmptyDataFeature = Object.values(featureLastWeekSummary).every((obj: any) => Object.keys(obj).length === 0);
			setisemptyData(isEmptyDataFeature);
			setFeatureSummaryReport(featureLastWeekSummary);
			setIsLoading({ ...isLoading, [index]: false });
		}).catch((err: any) => {
			console.log(err, 'err');
		});
		setWeeklySummaryDialogue(true);
		//  setWorkDuration(totalDuration);
	};


	const handleChange = async (
		event: SelectChangeEvent<string> | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		setIsFetching(true);
		const { value, name } = event.target;
		setMonthSelected(value);


		let username;
		if (employeeName === undefined || employeeName === '') {
			const projectLeadUser = employees.find((user: any) => `${user.firstName} ${user.lastName}` === projectLead);
			username = projectLeadUser.userName;
		} else {
			const teamUser = employees.find((user: any) => `${user.firstName} ${user.lastName}` === employeeName);
			username = teamUser.userName;
		}

		const firstDayEpoch = dayjs(value, 'MMMM').startOf('month').unix() * 1000;
		const lastDayEpoch = dayjs(value, 'MMMM').endOf('month').unix() * 1000;

		try {
			const data = await getUserReportData(firstDayEpoch, lastDayEpoch, username);
			const userReports = data.data.res.Items;
			const userReportsData = userReports.filter((item: any) => item.projectName === projectName);
			setIsFetching(false);
			setTeamMemberReport(userReportsData);
			setOpen(true);
			setAnchorEl(null);
		} catch (error) {
			console.log(error);
		}
	};
	const handleUserExport = async (reports: any, name: any, project: any) => {
		setIsUserLoading(true);
		const data: object[] = [];
		for (const key in reports) {
			const myReport: any = {};
			myReport['Project Name'] = reports[key]?.projectName;
			myReport['Date'] = dayjs(reports[key].activityDate).format(constants.DATE_FORMAT);
			myReport['Feature'] = reports[key].feature;
			myReport['Category'] = reports[key].activityType;
			myReport['Work Item'] = reports[key].workDescription;
			myReport['Duration'] = isNaN(reports[key].activityDuration) ? 0 : reports[key].activityDuration;
			myReport['Work Assigned By'] = reports[key]?.isource;
			myReport['Work Mode'] = reports[key]?.workMode;
			data.push(myReport);
		}

		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet('Report');
		const headers = ['Project Name', 'Date', 'Feature', 'Category', 'Work Item', 'Duration', 'Work Assigned By', 'Work Mode'];
		const headerRow = worksheet.addRow(headers);
		headerRow.eachCell((cell: any, colNumber: any) => {
			cell.fill = {
				type: 'pattern',
				pattern: 'solid',
				fgColor: { argb: 'FFF26A23' }
			};
			cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
			cell.alignment = { horizontal: 'center', vertical: 'middle' };
			worksheet.getColumn(colNumber).width = 25;
		});
		data.forEach((row) => {
			worksheet.addRow(Object.values(row));
		});
		worksheet.eachRow((row: any) => {
			row.eachCell((cell: any) => {
				cell.border = {
					top: { style: 'thin' },
					left: { style: 'thin' },
					bottom: { style: 'thin' },
					right: { style: 'thin' }
				};
			});
		});
		workbook.xlsx.writeBuffer().then((buffer: any) => {
			const file = new Blob([buffer], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			FileSaver.saveAs(file, `${name}_${project}_${dayjs(selectedStartDate).format('YYYY-MM-DD')}_${dayjs(selectedEndDate).format('YYYY-MM-DD')}.xlsx`);
		}).catch((err: any) => console.error('Error exporting file:', err));
		setIsUserLoading(false);
	};

	const handleMember = async (employeeName: any, { displayProjectName }: any) => {
		setOpenGrid(true);
		setProjectLead('');
		setEmployeeName(employeeName);
		setProjectName(displayProjectName);
		setIsFetching(true);
		const firstDayEpoch = dayjs(selectedStartDate).valueOf();
		const lastDayEpoch = dayjs(selectedEndDate).valueOf();
		const teamUser = employees.find(
			(user: any) => `${user.firstName} ${user.lastName}` === employeeName
		);
		const username = teamUser.userName;

		try {
			const data = await getUserReportData(firstDayEpoch, lastDayEpoch, username);
			const userReports = data.data.res.Items;
			const userReportsData = userReports.filter((item: any) => item.projectName === projectName);
			setIsFetching(false);
			setTeamMemberReport(userReportsData);
			setOpen(true);
			setAnchorEl(null);
		} catch (error) {
			console.log(error);
		}

		setOpenSelectfield(true);
	};


	const handleProjectLead = async (projectLead: any, projectName: any) => {
		setOpenGrid(true);
		setEmployeeName('');
		setProjectLead(projectLead);
		setProjectName(projectName);
		setIsFetching(true);
		const teamUser = employees.find(
			(user: any) => `${user.firstName} ${user.lastName}` === projectLead
		);
		const username = teamUser.userName;
		const firstDayEpoch = dayjs(selectedStartDate).valueOf();
		const lastDayEpoch = dayjs(selectedEndDate).valueOf();

		try {
			const data = await getUserReportData(firstDayEpoch, lastDayEpoch, username);
			const userReports = data.data.res.Items;
			const userReportsData = userReports.filter((item: any) => item.projectName === projectName);
			setIsFetching(false);
			setTeamMemberReport(userReportsData);
			setOpen(true);
			setAnchorEl(null);
		} catch (error) {
			console.log(error);
		}

		setOpenSelectfield(true);
		setMonthSelected('');
	};

	const handleProjectManagerClick = async (projectManager: any, projectName: any) => {
		setOpenGrid(true);
		setEmployeeName('');
		setProjectLead(projectManager);
		setProjectName(projectName);
		setIsFetching(true);
		const teamUser = employees.find(
			(user: any) => `${user.firstName} ${user.lastName}` === projectManager
		);
		const username = teamUser.userName;
		const firstDayEpoch = dayjs(selectedStartDate).valueOf();
		const lastDayEpoch = dayjs(selectedEndDate).valueOf();
		try {
			const data = await getUserReportData(firstDayEpoch, lastDayEpoch, username);
			const userReports = data.data.res.Items;
			const userReportsData = userReports.filter((item: any) => item.projectName === projectName);
			setIsFetching(false);
			setTeamMemberReport(userReportsData);
			setOpen(true);
			setAnchorEl(null);
		} catch (error) {
			console.log(error);
		}

		setOpenSelectfield(true);
		setMonthSelected('');
	};

	const handleTimelineExport = async (project: any, index: any) => {
		setIsTimelineLoading({ ...isLoading, [index]: true });
		const totalEmployeesInProject = project.employeesWorking;
		const firstDayEpoch = dayjs(selectedStartDate).valueOf();
		const lastDayEpoch = dayjs(selectedEndDate).valueOf();
		const requests: ReportRequest[] = totalEmployeesInProject.map((employee: string) => {
			const teamUser = employees.find((user: any) => `${user.firstName} ${user.lastName}` === employee);
			return teamUser ? {
				username: teamUser.userName,
				startDate: firstDayEpoch,
				endDate: lastDayEpoch
			} : null;
		}).filter(Boolean) as ReportRequest[];
		const responses = await getMonthlySummaryAllExceptions(requests);
		const reportArray: Report[] = [];
		responses.forEach((response, index) => {
			const userReports = response.data.res.Items;
			const employee = totalEmployeesInProject[index];
			userReports.forEach((userReport: any) => {
				reportArray.push({ ...userReport, employee });
			});
		});
		await generateExcelReport(project, firstDayEpoch, lastDayEpoch, employees, constants, generateHeadersForMonth, getMonthlySummaryAllExceptions);
		setIsTimelineLoading({ ...isLoading, [index]: false });
	};

	const handleTeamReportExport = async (project: any, index: any) => {
		setIsTeamReportLoading({ ...isLoading, [index]: true });
		const totalEmployeesInProject = project.employeesWorking;
		const firstDayEpoch = dayjs(selectedStartDate).valueOf();
		const lastDayEpoch = dayjs(selectedEndDate).valueOf();
		const requests: ReportRequest[] = totalEmployeesInProject.map((employee: string) => {
			const teamUser = employees.find((user: any) => `${user.firstName} ${user.lastName}` === employee);
			return teamUser ? {
				username: teamUser.userName,
				startDate: firstDayEpoch,
				endDate: lastDayEpoch
			} : null;
		}).filter(Boolean) as ReportRequest[];

		const responses = await getMonthlySummaryAllExceptions(requests);
		const reportArray: Report[] = [];
		responses.forEach((response, index) => {
			const userReports = response.data.res.Items;
			const employee = totalEmployeesInProject[index];
			userReports.forEach((userReport: any) => {
				reportArray.push({ ...userReport, employee });
			});
		});

		await generateTeamReport(project, firstDayEpoch, lastDayEpoch, employees, constants, responses);
		setIsTeamReportLoading({ ...isLoading, [index]: false });
	};

	const handleFeatureExport = async (employeesWorking: any, projectName: any, projectLead: any, index: any) => {
		setIsFeatureLoading({ ...isLoading, [index]: true });
		try {
			const firstDayEpoch = dayjs(selectedStartDate).valueOf();
			const lastDayEpoch = dayjs(selectedEndDate).valueOf();
			setWeeklyReportStart(dayjs(selectedStartDate).format('DD-MMM-YYYY'));
			setWeeklyReportEnds(dayjs(selectedEndDate).format('DD-MMM-YYYY'));
			const employeeUserNames: any = [];
			employeesWorking.forEach((data: any) => {
				const filteredData = employees.find((item: any) => `${item.firstName} ${item.lastName}` === data);
				if (filteredData) {
					employeeUserNames.push(filteredData.userName);
				}
			});
			const projectLeadName = projectLead?.split(' ') || [];
			const projectLeadEmployee = employees.find((employee: any) =>
				employee.firstName === projectLeadName[0] && employee.lastName === projectLeadName[1]
			);
			if (projectLeadEmployee) {
				employeeUserNames.push(projectLeadEmployee.userName);
			}

			const res = await getProjectData(employeeUserNames, firstDayEpoch, lastDayEpoch);
			const responsedata = res.data.mergedItems?.Items;
			let userReportsData = [];
			if (responsedata.length > 0) {
				userReportsData = responsedata?.filter((item: any) => item.projectName === projectName);
			} else {
				alert(`No data available for the selected ${projectName} download again...`);
			}
			const featureLastWeekSummary: any = {};

			userReportsData.forEach((element: any) => {
				const featureName = element.feature;
				const userName = element.userName;
				const employee = employees.find((employee: any) => employee.userName === userName);
				const fullName = employee ? `${employee.firstName} ${employee.lastName}` : '';

				if (!featureLastWeekSummary[fullName]) {
					featureLastWeekSummary[fullName] = {};
				}

				if (featureName === '') {
					if (!featureLastWeekSummary[fullName]['']) {
						featureLastWeekSummary[fullName][''] = { workitem: [], duration: 0, isource: [] };
					}
					featureLastWeekSummary[fullName][''].workitem.push(element.workDescription);
					featureLastWeekSummary[fullName][''].isource.push(element.isource ?? '');
					featureLastWeekSummary[fullName][''].duration += isNaN(parseFloat(element.activityDuration))
						? 0
						: parseFloat(parseFloat(element.activityDuration).toFixed(2));
				} else {
					if (!featureLastWeekSummary[fullName][featureName]) {
						featureLastWeekSummary[fullName][featureName] = { workitem: [], duration: 0, isource: [] };
					}
					featureLastWeekSummary[fullName][featureName].workitem.push(element.workDescription);
					featureLastWeekSummary[fullName][featureName].isource.push(element.isource ?? '');
					featureLastWeekSummary[fullName][featureName].duration += isNaN(parseFloat(element.activityDuration))
						? 0
						: parseFloat(parseFloat(element.activityDuration).toFixed(2));
				}
			});

			for (const key in featureLastWeekSummary) {
				const projectDetails = featureLastWeekSummary[key];
				for (const task in projectDetails) {
					if (task === 'undefined') {
						delete projectDetails[task];
					}
				}
			}
			for (const key in featureLastWeekSummary) {
				if (Object.keys(featureLastWeekSummary[key]).length === 0) {
					delete featureLastWeekSummary[key];
				}
			}
			const isEmptyDataFeature = Object.values(featureLastWeekSummary).every((obj: any) => Object.keys(obj).length === 0);
			setisemptyData(isEmptyDataFeature);
			setFeatureSummaryReport(featureLastWeekSummary);
			if (Object.keys(featureLastWeekSummary).length === 0) {
				alert(`No data available for the selected period for ${projectName} or api with no response download again...`);
				return;
			}
			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet('Feature Report');
			const headers = ['Employee Name', 'Feature', 'Work Items', 'Source', 'Duration'];
			headers.forEach((header, index) => {
				const cell = worksheet.getCell(1, index + 1);
				cell.value = header;
				cell.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'FFF26A23' }
				};
				cell.font = { color: { argb: 'FFFFFFFF' } };
				cell.alignment = { horizontal: 'center', vertical: 'middle' };
				worksheet.getColumn(index + 1).width = 20;
			});

			Object.entries(featureLastWeekSummary).forEach(([employeeName, task]: any) => {
				let fullName = employeeName;
				if (employeeName.startsWith('google')) {
					const employee = employees.find((employee: any) => employee.userName === employeeName);
					fullName = employee ? `${employee.firstName} ${employee.lastName}` : employeeName;
				}
				Object.keys(task).forEach((feature) => {
					const { workitem, duration, isource } = task[feature];
					const startRow = worksheet.rowCount + 1;
					let employeeNameMerged = false;
					let featureMerged = false;
					let durationMerged = false;

					workitem.forEach((item: string, index: number) => {
						if (index === 0) {
							worksheet.addRow([fullName, feature, item, isource[index], duration]);
						} else {
							worksheet.addRow(['', '', item, isource[index], '']);
						}
					});

					const endRow = worksheet.rowCount;
					if (startRow !== endRow) {
						if (!employeeNameMerged) {
							worksheet.mergeCells(`A${startRow}:A${endRow}`);
							employeeNameMerged = true;
						}
						if (!featureMerged) {
							worksheet.mergeCells(`B${startRow}:B${endRow}`);
							featureMerged = true;
						}
						if (!durationMerged) {
							worksheet.mergeCells(`E${startRow}:E${endRow}`);
							durationMerged = true;
						}
					}
				});
			});

			worksheet.columns.forEach(column => {
				column.width = 20;
			});

			const buffer = await workbook.xlsx.writeBuffer();
			const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const fileName = 'FeatureReport_' + dayjs(firstDayEpoch).format(constants.DATE_FORMAT) + '_to_' + dayjs(lastDayEpoch).format(constants.DATE_FORMAT) + '.xlsx';
			FileSaver.saveAs(blob, fileName);
		} catch (error) {
			console.error('Error generating feature export:', error);
		} finally {
			setIsFeatureLoading({ ...isLoading, [index]: false });
		}
	};

	useEffect(() => {
		const currentMonthIndex = new Date().getMonth();
		const currentMonth = constants.MONTHS[currentMonthIndex];
		setMonthSelected(currentMonth);
	}, []);


	const handleTeamReportClick = (project: any, index: number) => {
		setLoadingState({ ...loadingState, teamReport: true });
		handleTeamReportExport(project, index).finally(() => {
			setLoadingState({ ...loadingState, teamReport: false });
			handleDownloadClose();
		});
	};

	const handleTimelineClick = (project: any, index: number) => {
		setLoadingState({ ...loadingState, timeline: true });
		handleTimelineExport(project, index).finally(() => {
			setLoadingState({ ...loadingState, timeline: false });
			handleDownloadClose();
		});
	};

	const handleFeatureClick = (project: any, index: number) => {
		setLoadingState({ ...loadingState, feature: true });
		handleFeatureExport(project.employeesWorking, project.displayProjectName, project.projectLead, index).finally(() => {
			setLoadingState({ ...loadingState, feature: false });
			handleDownloadClose();
		});
	};

	const handleTableExport = async (rows: any[], fileNamePrefix: string) => {
		try {
			if (!rows || rows.length === 0) return;

			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet('Data');

			const headers = Object.keys(rows[0] || {});
			const headerRow = worksheet.addRow(headers);

			headerRow.eachCell((cell: any, colNumber: number) => {
				cell.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'FFF26A23' } // Orange background
				};
				cell.font = {
					bold: true,
					color: { argb: 'FFFFFFFF' }, // White text
					size: 10
				};
				cell.alignment = { horizontal: 'center', vertical: 'middle' };
				worksheet.getColumn(colNumber).width = 25;
			});
			rows.forEach((row) => {
				const rowData = headers.map((key) => row[key]);
				worksheet.addRow(rowData);
			});
			worksheet.eachRow((row: any) => {
				row.eachCell((cell: any) => {
					cell.border = {
						top: { style: 'thin' },
						left: { style: 'thin' },
						bottom: { style: 'thin' },
						right: { style: 'thin' }
					};
				});
			});
			const buffer = await workbook.xlsx.writeBuffer();
			const blob = new Blob([buffer], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			const fileName = `${fileNamePrefix}_${dayjs().format('DD-MMM-YYYY_HH-mm')}.xlsx`;
			FileSaver.saveAs(blob, fileName);
		} catch (err) {
			console.error('Export failed', err);
		}
	};

	const filterProjectsByUser = (projects:any , user: User) => {
		return projects.filter((project: any) =>
			project.projectLead === `${user.firstName} ${user.lastName}` || project.projectManger === `${user.firstName} ${user.lastName}`
		);
	};

	return (
		<Box>
			<Grid container spacing={2} sx={{ padding: 0 }}>
				<Grid item display={{ md: 'none', sm: 'block' }}>
					<IconButton
						aria-controls={openMenu ? 'basic-menu' : undefined}
						aria-haspopup="true"
						aria-expanded={openMenu ? 'true' : undefined}
						onClick={handleClick}
					>
						<ListIcon />
					</IconButton>
				</Grid>
				<Grid item xs={12} md={4} lg={3} style={{ display: isSmallScreen ? 'none' : 'block' }}  >
					<Paper elevation={0} className='scroll' style={{ height: '90vh', overflow: 'scroll' }} sx={{ border: '1px solid #D8D5FF', borderRadius: '10px' }}>
						<MenuList>
							{filterProjectsByUser(newProject,user).map((project: any, index: any) => (
								<React.Fragment key={index}>
									<MenuItem>
										<ListItemText sx={{ padding: 0 }}>
											<Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
												<Typography
													variant="subtitle1"
													color="#7660db"
													sx={{ padding: 0, fontWeight: 'bold' }}
													onClick={() => handleProjectNameSummary([...project.employeesWorking, project.projectLead, project.projectManger], project.displayProjectName)}
												>
													{project.displayProjectName}
												</Typography>
												<Stack spacing={2} direction='row'>
													{!isLoading[index] ? (
														<Tooltip title="Team Summary">
															<IconButton onClick={() => handleSummary(project.employeesWorking, project.displayProjectName, project.projectLead, index)}>
																<AssignmentIcon style={{ width: '20px', height: '20px', color: '#7660db' }} />
															</IconButton>
														</Tooltip>
													) : (
														<Box display="flex" alignItems="center" justifyContent="center">
															<CircularProgress size={20} color="secondary" />
														</Box>
													)}
													<>
														<Tooltip title="Download Options">
															<IconButton onClick={(event) => handleDownloadClick(event, project)}>
																<SimCardDownloadOutlinedIcon style={{ width: '20px', height: '20px', color: '#7660db' }} />
															</IconButton>
														</Tooltip>

														<Menu anchorEl={downloadAnchorEl} open={Boolean(downloadAnchorEl)} onClose={handleDownloadClose}>
															<MenuItem onClick={() => handleTeamReportClick(projectData, index)}>
																<GroupOutlinedIcon style={{ marginRight: 8, width: '20px', height: '20px', color: '#7660db' }} />
																{MY_TEAM_DOWNLOAD_TITLES.TEAM_REPORT_EXPORT}
																{loadingState.teamReport ? (
																	<CircularProgress size={20} color="secondary" style={{ marginLeft: 8 }} />
																) : (
																	<Box style={{ width: 20, height: 20, marginLeft: 8 }} />
																)}
															</MenuItem>

															<MenuItem onClick={() => handleTimelineClick(projectData, index)}>
																<TimelineOutlinedIcon style={{ marginRight: 8, width: '20px', height: '20px', color: '#7660db' }} />
																{MY_TEAM_DOWNLOAD_TITLES.TIMELINE_REPORT_EXPORT}
																{loadingState.timeline ? (
																	<CircularProgress size={20} color="secondary" style={{ marginLeft: 8 }} />
																) : (
																	<Box style={{ width: 20, height: 20, marginLeft: 8 }} />
																)}
															</MenuItem>


															<MenuItem onClick={() => handleFeatureClick(projectData, index)}>
																<AssessmentOutlinedIcon style={{ marginRight: 8, width: '20px', height: '20px', color: '#7660db' }} />
																{MY_TEAM_DOWNLOAD_TITLES.FEATURE_REPORT_EXPORT}
																{loadingState.feature ? (
																	<CircularProgress size={20} color="secondary" style={{ marginLeft: 8 }} />
																) : (
																	<Box style={{ width: 20, height: 20, marginLeft: 8 }} />
																)}
															</MenuItem>
														</Menu>
													</>
												</Stack>
											</Box>
										</ListItemText>
									</MenuItem>
									<Divider sx={{ borderBottom: '1px solid #D8D5FF' }} />
									<List>
										{employees.find(
											(value: any) =>
												value.employeeStatus === true &&
												`${value.firstName} ${value.lastName}` === project.projectManger && project.projectManger !== ''
										) &&
											<ListItem sx={{ '&:hover': { background: '#fff9f3' }, cursor: adminReport ? (project.projectManger ? 'pointer' : '') : 'default' }}
												onClick={() => adminReport ? handleProjectManagerClick(project.projectManger, project.displayProjectName) : ''}>
												<ListItemAvatar>
													<Avatar variant='rounded' src={project.projectManger && employees.find((emp: any) => `${emp.firstName} ${emp.lastName}` === project.projectManger && emp.employeeStatus === true)?.picture} sx={{ background: generateRandomLightColor, width: '30px', height: '30px' }} />
												</ListItemAvatar>
												<Box >
													<Typography sx={MyTeamStyles.name}>{project.projectManger}</Typography>
													<Typography sx={MyTeamStyles.subtitle1} variant="subtitle1">Project Manager</Typography>
												</Box>

											</ListItem>}
										{employees.find(
											(value: any) =>
												value.employeeStatus === true &&
												`${value.firstName} ${value.lastName}` === project.projectLead && project.projectLead !== ''
										) &&
											<ListItem sx={{
												'&:hover': { background: '#fff9f3' },
												cursor: project.projectLead ? 'pointer' : '',
												backgroundColor: projectLead === project.projectLead && projectName === project.displayProjectName ? 'rgb(245,244,255)' : 'inherit',
											}} onClick={() => project.projectLead && handleProjectLead(project.projectLead, project.displayProjectName)}   >
												<ListItemAvatar>
													<Avatar variant='rounded' src={project.projectLead && employees.find((emp: any) => `${emp.firstName} ${emp.lastName}` === project.projectLead && emp.employeeStatus == true)?.picture} sx={{ background: generateRandomLightColor, width: '30px', height: '30px' }} />
												</ListItemAvatar>
												<Box >
													<Typography sx={MyTeamStyles.name} >{project.projectLead}</Typography>
													<Typography sx={MyTeamStyles.subtitle1} variant="subtitle1">Project Lead</Typography>
												</Box>

											</ListItem>}
										{project.employeesWorking
											.filter((employee: any) => {
												const empData = employees.find((emp: any) => `${emp.firstName} ${emp.lastName}` === employee && emp.employeeStatus === true);
												return empData;
											})
											.map((employee: any, idx: any) => (
												<ListItem key={idx} onClick={() => handleMember(employee, project)} sx={{
													'&:hover': { background: '#fff9f3' },
													cursor: 'pointer',
													fontWeight: employeeName === employee && projectName === project.displayProjectName ? 'bold' : 'normal',
													backgroundColor: employeeName === employee && projectName === project.displayProjectName ? 'rgb(245,244,255)' : 'inherit',
												}}>
													<ListItemAvatar>
														<Avatar variant='rounded' src={employees.find((emp: any) => `${emp.firstName} ${emp.lastName}` === employee && emp.employeeStatus === true)?.picture} sx={{ background: generateRandomLightColor, width: '30px', height: '30px' }} />
													</ListItemAvatar>
													<Box>
														<Typography sx={MyTeamStyles.name} >{employee}</Typography>
														<Typography sx={MyTeamStyles.subtitle1} variant="subtitle1">Member</Typography>
													</Box>
												</ListItem>
											))}
									</List>
									<Divider sx={{ borderBottom: '1px solid #D8D5FF' }} />
								</React.Fragment>
							))}
							{filterProjectsByUser(newProject,user)?.length === 0 && <Typography sx={{ marginTop: '300px', textAlign: 'center' }}>-- No Projects--</Typography>}
						</MenuList>
					</Paper>
				</Grid>
				<Grid item xs={12} md={8} lg={9}  >
					<Stack direction='row' spacing={2} justifyContent={'flex-end'}>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<FormControl sx={{ m: 1 }}>
								<CustomDateRangePicker
									onDateChange={handleCustomDateChange}
									label={`${dayjs(selectedStartDate).format(constants.DATE_FORMAT)} To ${dayjs(selectedEndDate).format(constants.DATE_FORMAT)}`}
								/>
							</FormControl>
						</LocalizationProvider>
					</Stack>
					{isProjectLoading === false && showDatagrid ? (
						<Paper elevation={0} sx={{ width: '100%' }}>
							{[
								{ title: `Plan For the day ${projectName}`, rows: isPlanForDay },
								{ title: `Work log of ${projectName}`, rows: isSelectedData }
							].map((section, index) => (
								<Box key={index}>
									<Grid container sx={{ ...MyTeamStyles.gridContainer, margin: '10px' }} >
										<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
											<Typography variant="subtitle1" sx={{ fontWeight: '600' }}>{section.title}</Typography>
											<Button
												size="small"
												color='primary'
												sx={{ ml: 2 }}
												startIcon={<UploadFileIcon />}
												onClick={() => handleTableExport(section.rows || [], section.title.replace(/\s+/g, '_'))}
											>
												Export
											</Button>
										</Stack>
									</Grid>
									<DataGrid
										sx={{
											'& .MuiDataGrid-cell--editable:hover': { bgcolor: 'inherit' },
											'& .MuiDataGrid-cell': { bgcolor: '#F2F2F2', cursor: 'not-allowed' },
											'& .MuiDataGrid-cell--editable': { bgcolor: '#f9f9f9', cursor: 'pointer' }
										}}
										rows={section.rows || []}
										getRowId={(row) => row.reportId}
										columns={getReportsMyTeamColumnDefs(setShowAlert, setWarningMessage, projects, user, employees, adminReport, features)}
										rowHeight={section.rows.length ? 35 : 100}
										disableSelectionOnClick
										autoHeight
										experimentalFeatures={{ newEditingApi: true }}
										isCellEditable={() => constants.ADMIN_TYPE_LIST.includes(user.employeeType)}
										sortingOrder={['asc', 'desc']}
										page={page - 1}
										rowsPerPageOptions={[]}
										onPageChange={(newPage) => setPage(newPage + 1)}
										paginationMode="server"
										pagination
										filterMode="server"
									/>
								</Box>
							))}
						</Paper>
					) :
						isProjectLoading === true && <Stack spacing={2} sx={MyTeamStyles.noDataContainer}>
							<CircularProgress size={50} color="secondary" /></Stack>
					}

					{openGrid && (constants.ADMIN_TYPE_LIST.includes(user.employeeType) || user.showTeamDetails) ? (
						<Paper elevation={0}  >
							<Grid container sx={MyTeamStyles.gridContainer} >
								<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
									<Typography variant="subtitle1" sx={{ fontWeight: '600' }}>
										{projectLead} {employeeName} ({projectName})
									</Typography>
									<Button size='small'
										variant='contained'
										color="secondary"
										style={Style.newRowButton}
										startIcon={<UploadFileIcon />}
										endIcon={isUserLoading ? < CircularProgress color="success" style={Style.progress} /> : null}
										onClick={() => handleUserExport(teamMemberReport, employeeName ? employeeName : projectLead, projectName)}>Export</Button>
								</Stack>
								<Grid item sm={6} xs={12} display={'flex'} justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}>
								</Grid>
							</Grid>
							<DataGrid
								sx={{
									'& .MuiDataGrid-cell--editable:hover': {
										bgcolor: () => 'inherit',
									},
									'& .MuiDataGrid-cell': {
										bgcolor: () => '#F2F2F2',
										cursor: 'not-allowed'
									},
									'& .MuiDataGrid-cell--editable': {
										bgcolor: () => '#f9f9f9',
										cursor: 'pointer'
									}
								}}
								loading={isFetching}
								rows={teamMemberReport}
								columns={getReportsMyTeamColumnDefs(setWarningMessage, setShowAlert, projects, user, employees, adminReport, features)}
								rowHeight={teamMemberReport.length ? 35 : 100}
								disableSelectionOnClick
								autoHeight
								experimentalFeatures={{ newEditingApi: true }}
								getRowId={(row) => row?.reportId}
								isCellEditable={() => {
									if (constants.ADMIN_TYPE_LIST.includes(user.employeeType)) {
										return true;
									}
									return true;
								}}
								sortingOrder={['asc', 'desc']}
								page={page - 1}
								rowsPerPageOptions={[]}
								onPageChange={(newPage) => {
									setPage(newPage + 1);
								}}
								paginationMode="server"
								pagination={true}
								filterMode='server'
							/>

						</Paper>
					) : (
						<Stack spacing={2} sx={MyTeamStyles.noDataContainer}>
							<AssignmentIcon style={{ width: '100px', height: '100px', color: '#d9d9d9' }} />
							<Typography variant='h6' sx={{ color: '#d9d9d9' }}>Click on Employee Name or Project Name to display Reports</Typography>
						</Stack>
					)}
					<Menu
						className='scroll'
						id="basic-menu"
						anchorEl={anchorEl}
						open={openMenu}
						onClose={handleClose}
						style={{ width: '100%' }}
						MenuListProps={{
							'aria-labelledby': 'basic-button',
						}}
					>
						<IconButton sx={{ marginLeft: '45%' }} onClick={handleClose}><GridCloseIcon /></IconButton>
						<Grid item xs={12} style={{ width: '100%', padding: '10px' }}  >
							<Paper elevation={0} className='scroll' style={{ height: '80vh', overflow: 'scroll', minWidth: '90vw' }} sx={{ border: '1px solid #D8D5FF', borderRadius: '10px' }}>
								<MenuList>
									{filterProjectsByUser(newProject, user).map((project: any, index: any) => (
										<React.Fragment key={index}>
											<MenuItem>
												<ListItemText sx={{ padding: 0 }}>
													<Typography variant="subtitle1" color="#7660db" sx={{ padding: 0, fontWeight: 'bold' }}>
														{project.displayProjectName}
													</Typography>
												</ListItemText>
											</MenuItem>
											<Divider sx={{ borderBottom: '1px solid #D8D5FF' }} />
											<List>
												<ListItem sx={{ '&:hover': { background: '#fff9f3' } }}>
													<ListItemAvatar>
														<Avatar variant='rounded' src={project.projectManger && employees.find((emp: any) => `${emp.firstName} ${emp.lastName}` === project.projectManger)?.picture} sx={{ background: generateRandomLightColor, width: '30px', height: '30px' }} />
													</ListItemAvatar>
													<Box >
														<Typography sx={MyTeamStyles.name}>{project.projectManger}</Typography>
														<Typography sx={MyTeamStyles.subtitle1} variant="subtitle1">Project Manager</Typography>
													</Box>

												</ListItem>
												<ListItem sx={{
													'&:hover': { background: '#fff9f3' },
													cursor: project.projectLead ? 'pointer' : 'not-allowed',
													backgroundColor: projectLead === project.projectLead && projectName === project.displayProjectName ? 'rgb(245,244,255)' : 'inherit',
												}} onClick={() => project.projectLead && handleProjectLead(project.projectLead, project.displayProjectName)}   >
													<ListItemAvatar>
														<Avatar variant='rounded' src={project.projectLead && employees.find((emp: any) => `${emp.firstName} ${emp.lastName}` === project.projectLead)?.picture} sx={{ background: generateRandomLightColor, width: '30px', height: '30px' }} />
													</ListItemAvatar>
													<Box >
														<Typography sx={MyTeamStyles.name}>{project.projectLead}</Typography>
														<Typography sx={MyTeamStyles.subtitle1} variant="subtitle1">Project Lead</Typography>
													</Box>

												</ListItem>
												{project.employeesWorking.map((employee: any, idx: any) => (
													<ListItem key={idx} onClick={() => handleMember(employee, project)} sx={{
														'&:hover': { background: '#fff9f3' },
														cursor: 'pointer',
														fontWeight: employeeName === employee && projectName === project.displayProjectName ? 'bold' : 'normal',
														backgroundColor: employeeName === employee && projectName === project.displayProjectName ? 'rgb(245,244,255)' : 'inherit',
													}}>
														<ListItemAvatar>
															<Avatar variant='rounded' src={employees.find((emp: any) => `${emp.firstName} ${emp.lastName}` === employee)?.picture} sx={{ background: generateRandomLightColor, width: '30px', height: '30px' }} />
														</ListItemAvatar>
														<Box>
															<Typography sx={MyTeamStyles.name}>{employee}</Typography>
															<Typography sx={MyTeamStyles.subtitle1} variant="subtitle1">Member</Typography>
														</Box>
													</ListItem>
												))}
											</List>
											<Divider sx={{ borderBottom: '1px solid #D8D5FF' }} />
										</React.Fragment>
									))}
								</MenuList>
							</Paper>
						</Grid>
					</Menu>
				</Grid>
			</Grid>

			<BootstrapDialog onClose={handleCloseDialogueBox} open={weeklySummaryDialogue}>
				<DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold', textAlign: 'center' }}>
					My Team Reports ({weeklyReportStart} to {weeklyReportEnds})
					<IconButton onClick={handleCloseDialogueBox} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}>
						<GridCloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent className='scroll' dividers sx={{ width: '800px', maxWidth: '100%' }}>
					{!isEmptyData ? (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
						<Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}> Reports Based on Category</Typography>
					</Box>) : null}
					{isEmptyData ? (
						<Typography
							sx={{
								fontWeight: 'bold',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center'
							}}
							variant='subtitle1'
						>
							No Report Available
						</Typography>
					) : (
						Object.entries(formatData).map(([employeeId, task]: any) => {
							const employee = employees.find((employee: any) => employee.userName === employeeId);
							const firstName = employee?.firstName || '';
							const lastName = employee?.lastName || '';

							return (
								<Fragment key={employeeId}>
									<Typography sx={{ fontWeight: 'bold', padding: '20px 0' }} variant='h6'>
										{firstName} {lastName}
									</Typography>
									<Paper elevation={0} sx={{ width: '100%', minWidth: '520px', border: '1px solid #e2e2e2', borderBottom: 'none' }}>
										<TableContainer sx={{ width: '100%', minWidth: '500px' }}>
											<Table stickyHeader size="small" aria-label="a dense table">
												<TableHead key={employeeId}>
													<TableRow style={{ padding: '0' }}>
														<StyledTableCell style={{ width: '40%' }}>Category</StyledTableCell>
														<StyledTableCell style={{ width: '40%' }}>WorkItems</StyledTableCell>
														<StyledTableCell style={{ width: '20%' }}>Duration</StyledTableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{Object.entries(task).map(([key, value]: any) => (
														value.duration !== 0 ? (
															<TableRow key={key}>
																<TableCell >{key === '' ? 'Other' : key}</TableCell>
																<TableCell >
																	{value.workitem.map((element: string, Key: string) => (
																		<ul key={Key} style={{ padding: 0 }}>
																			<li>{element}</li>
																		</ul>
																	))}
																</TableCell>
																<TableCell>
																	{Number.isFinite(value?.duration)
																		? Number.isInteger(value.duration)
																			? value.duration
																			: value.duration.toFixed(2)
																		: '0'}
																</TableCell>
															</TableRow>
														) : null
													))}
												</TableBody>
											</Table>
										</TableContainer>
									</Paper>
								</Fragment>
							);
						})
					)}


					{!isEmptyData ? (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '30px' }}>
						<Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}> Reports Based on Feature</Typography>
					</Box>) : null}
					{isEmptyData ? (
						<Typography
							sx={{
								fontWeight: 'bold',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center'
							}}
							variant='subtitle1'
						>
							No Feature Available
						</Typography>
					) : (
						Object.entries(featureSummaryReport).map(([employeeId, task]: any) => {
							const employee = employees.find((employee: any) => employee.userName === employeeId);
							const firstName = employee?.firstName || '';
							const lastName = employee?.lastName || '';

							return (
								<Fragment key={employeeId}>
									<Typography sx={{ fontWeight: 'bold', padding: '20px 0' }} variant='h6'>
										{firstName} {lastName}
									</Typography>
									<Paper
										elevation={0}
										sx={{ width: '100%', minWidth: '520px', border: '1px solid #e2e2e2', borderBottom: 'none' }}
									>
										<TableContainer sx={{ width: '100%', minWidth: '500px' }}>
											<Table stickyHeader size="small" aria-label="a dense table">
												<TableHead>
													<TableRow style={{ padding: '0' }}>
														<StyledTableCell style={{ width: '40%' }}>Feature</StyledTableCell>
														<StyledTableCell style={{ width: '40%' }}>WorkItems</StyledTableCell>
														<StyledTableCell style={{ width: '20%' }}>Duration</StyledTableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{Object.entries(task).map(([key, value]: any) => {
														if (value.duration !== 0) {
															return (
																<TableRow key={key}>
																	<TableCell>{key === '' ? 'Other' : key}</TableCell>
																	<TableCell>
																		<ul style={{ padding: 0 }}>
																			{value.workitem.map((element: string, key: string) => (
																				<li key={key}>{element}</li>
																			))}
																		</ul>
																	</TableCell>
																	<TableCell>
																		{Number.isFinite(value?.duration)
																			? Number.isInteger(value.duration)
																				? value.duration
																				: value.duration.toFixed(2)
																			: '0'}
																	</TableCell>
																</TableRow>
															);
														}
														return null;
													})}
												</TableBody>
											</Table>
										</TableContainer>
									</Paper>
								</Fragment>
							);
						})
					)}

				</DialogContent>
			</BootstrapDialog>
		</Box>
	);
};
